<template>
    <div class="page">
        <Headers></Headers>

        <div class="banner">

            <!-- 本页标题 -->
            <div class="banner_title">Background </div>

            <!-- 内容 -->
            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">Purpose of the Carbon Neutrality Rating <span class="btm_line"></span></div>
                    <div class="txt">Natural disasters caused by global warming are challenges that mankind must face. Carbon neutrality is a collective global response to climate change. It is also a path forward for major economies around the world to taking responsibility for combating climate change. Carbon neutrality has presented enterprises with additional requirements for their operations, services, supply chain management, strategic development, and investment, etc. As a result, it has become an important dimension of corporate sustainable development to evaluate whether a company or organization has achieved carbon neutrality, and how it is contributing to the progress towards carbon neutrality. Through this evaluation system and the ratings, we hope to work with enterprises to jointly prompt more actions in the direction of carbon neutrality.</div>
                </a-col>
                <a-col>
                    <img src="@/assets/img/t_img.png" class="img_box" alt="">
                </a-col>
            </a-row>

            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">About the Carbon Neutrality Rating System <span class="btm_line"></span></div>
                    <div class="txt">The Carbon Neutrality Rating is jointly developed by Metaverse Green Exchange （MVGX） and Asia Carbon Neutrality Assessment Center （ACNAC） according to the “CarbonSpace” Standard. It has been certified internationally by TÜV SÜD. By incorporating factors such as an enterprise’s carbon emissions and its emission reduction efforts, the Rating system is a customizable methodology that evaluates and scores the carbon neutrality performance by an enterprise on multiple dimensions, producing a summary score that indicates the enterprise’s status towards carbon neutrality operations relative to its size and industry peers. The evaluation dimensions include direct emissions, indirect emissions, direct contribution to emission reduction, indirect contribution to emission reduction, zero-carbon operations, green supply chain, pledges and disclosure, and zero-carbon investment. Each dimension has a maximum score of 100 points but carries a different weight in the calculation of the summary score.  Based on the CarbonSpace Standard, TÜV SÜD evaluates and certifies an enterprise on each dimension by incorporating disclosed data and actions, and by referencing to its size and industry sector peers. A summary score and sector specific ranking are then calculated to arrive at a final rating for the enterprise.</div>
                </a-col>
                <a-col :span="9">
                    <!-- <img src="@/assets/img/banner_cankao.png" class="cank_box" alt=""> -->
                    <div class="charts">
                        <Echarts v-if="PdftStore.fromData.questionnaireInfo" :name="'page3echarts'"/>
                    </div>
                </a-col>
            </a-row>

            <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">Benefits of Being Rated <span class="btm_line"></span></div>
                    <div class="txt">The evaluation and rating on the Carbon Neutrality Index can help enterprises understand the gap between their own carbon emissions and those of the leaders in their respective industries, contributing to climate change risk management and control. Highly rated companies can stand out on the market, showcasing environment-friendly management and commitment to social responsibility while benefiting from brand building. The evaluation process and result can help enterprises meet policy requirements, reduce operating costs, as well as obtain carbon reduction benefits as the world trends towards a carbon neutral future. </div>
                </a-col>
            </a-row>

            <!-- <a-row type="flex" class="mg_t" justify="space-between">
                <a-col :span="15">
                    <div class="t1">About TÜV SÜD <span class="btm_line"></span></div>
                    <div class="txt">TÜV SÜD is a leading international third-party monitoring certification and technical service organization with a history of more than 150 years and global sales of over 2.5 billion euros. In the field of sustainable development and carbon neutrality, we are committed to providing one-stop third-party services for sustainable development, digitalization and decarbonization.</div>
                </a-col>
                <a-col :span="9">
                    <div class="mg_c">
                        <img src="@/assets/img/onelogo.png" class="tuvlogo_box" alt="">
                    </div>
                </a-col>
            </a-row> -->

            <div class="logo_txt">
                <!-- <div>This report is commissioned by ACNAC, certified and published by </div>
                <img src="@/assets/img/min_tuv.png" class="img_min" alt="">
                <div> TÜV SÜD</div> -->
            </div>

            <div class="flxed">01</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
export default {
    name: 'page3',
    components:{Headers,Echarts},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .banner_title{
            padding: 60px 0 40px 0;
            font-size: 72px;
            font-weight: 500;
            color: #013C89;
            line-height: 100px;
            border-bottom: 2px solid #013C89;
        }
        .mg_t{
            margin-top: 126px;
        }
        .t1{
            font-size: 32px;
            font-weight: 500;
            color: #333333;
            line-height: 45px;
            width: 1200px;
        }
        .txt{
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 28px;
            margin-top: 24px;
            text-align: justify;
        }
        .btm_line{
            display: inline-block;
            width: 36px;
            height: 4px;
            background: #0DC7F5;
            transform: translateY(5px);
        }
        .img_box{
            width:440px;
            height: 270px;
            margin-left: 20px;
            margin-top: 80px;
        }
        .cank_box{
            width:388px;
            height: 363px;
        }
        .tuvlogo_box{
            width:195px;
            height: 195px;
            margin-left: 210px;
        }
        .mg_c{
            width: 100%;
        }
        .btm_banner{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            text-align: right;
            padding: 16px 0 0 0;
            border-top: 2px solid #013C89;
            margin-top: 105px;
        }
        .logo_txt{
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            text-align: right;
            padding: 16px 0 0 0;
            justify-content: flex-end;
            border-top: 2px solid #013C89;
            margin-top: 105px;
            display: flex;
            align-items: center;
            .img_min{
                width: 20px;
                height: 20px;
                margin: 0 5px;
            }
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
    }
}
.charts{
    width: 440px;
    height: 440px;
    margin: 60px 0 0 50px;
}
</style>